import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import DqListRouter from './DqList'
import AllRouter from './all'
import coursesRouter from './courses'
// import Chinesefood from '../views/dqList/ChineseFood.vue'

Vue.use(VueRouter)

// 阶级路由重复点击报错 Avoided redundant navigation
const originalPush = VueRouter.prototype.push
   VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
const routes = [
	{
		path: '/',
		name: 'home',
		component: Home
	},
	DqListRouter,
	AllRouter,
	coursesRouter
]
const router = new VueRouter({
	mode: 'history',
	routes
})

export default router